var _defs, _text, _text2, _text3, _text4, _text5, _g, _g2, _g3, _g4, _path, _text6, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargebicyclestand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1490,
    height: 1704,
    viewBox: "0 0 1490 1704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#a1a0a0;font-size:22px;font-family:DMSans-Regular,DM Sans}.cls-10,.cls-12,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:none}.cls-2,.cls-3,.cls-6{stroke:#a1a0a0;stroke-width:2px}.cls-2,.cls-6,.cls-7,.cls-8{stroke-linecap:round}.cls-2,.cls-7,.cls-8{stroke-linejoin:round}.cls-4,.cls-5{stroke:#000}.cls-4{stroke-width:3px}.cls-10,.cls-7{stroke:#707070}.cls-8{stroke:#323232}.cls-11,.cls-13{stroke:none}.cls-13{fill:#707070}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Large_bicycle_stand",
    "data-name": "Large bicycle stand",
    transform: "translate(-131.81 -178.5)"
  }, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_48.80",
    "data-name": 48.8,
    className: "cls-1",
    transform: "translate(144.186 506)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "48.80"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_36.00_",
    "data-name": 36,
    className: "cls-1",
    transform: "translate(216.81 602.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "36.00 "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_65.00",
    "data-name": 65,
    className: "cls-1",
    transform: "translate(131.81 1488)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "65.00"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_79.00",
    "data-name": 79,
    className: "cls-1",
    transform: "translate(762 906.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "79.00"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(223.81 1226)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_3_bikes_FRONT",
    "data-name": "TULU ride - 3 bikes FRONT",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086",
    transform: "rotate(-90 1384.986 442.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "rotate(90 -119.647 1077.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-2",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-2",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(0 7.227)",
    d: "M284.162 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-2",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-2",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089",
    transform: "translate(1102.81 1904.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-3",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-3",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M424.689 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-3",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-3",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "rotate(180 1016.155 959.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-4",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-4",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M421.809 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-4",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-4",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_467",
    "data-name": "Line 467",
    className: "cls-2",
    transform: "translate(924.186 1192.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_468",
    "data-name": "Line 468",
    className: "cls-2",
    transform: "translate(979.02 1380.5)",
    d: "M109.667 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_471",
    "data-name": "Line 471",
    className: "cls-2",
    transform: "translate(924.186 1833.5)",
    d: "M164.5 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_472",
    "data-name": "Line 472",
    className: "cls-2",
    transform: "translate(1096.31 1842.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_473",
    "data-name": "Line 473",
    className: "cls-2",
    transform: "translate(2043.5 1842.667)",
    d: "M0 0v93.166"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2047",
    "data-name": "Rectangle 2047",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h38v452H0z",
    transform: "translate(1097 1381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(1097 1381)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h24v119H0z",
    transform: "translate(1110.424 1264.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(1110.424 1264.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2050",
    "data-name": "Rectangle 2050",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h24v119H0z",
    transform: "translate(2005 1264.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h21v116h-21z",
    transform: "translate(2005 1264.833)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2051",
    "data-name": "Rectangle 2051",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h38v452H0z",
    transform: "translate(2005 1381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h35v449h-35z",
    transform: "translate(2005 1381)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M26 0h866.19a26 26 0 0 1 26 26v49H0V26A26 26 0 0 1 26 0z",
    transform: "translate(1110.81 1193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M26 1.5h866.19a24.5 24.5 0 0 1 24.5 24.5v46a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 72V26A24.5 24.5 0 0 1 26 1.5z",
    transform: "translate(1110.81 1193)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h875.19v48H0z",
    transform: "translate(1133 1785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h872.19v45H1.5z",
    transform: "translate(1133 1785)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h42v37H0z",
    transform: "translate(1252 1376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1252 1376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h42v37H0z",
    transform: "translate(1551.496 1376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1551.496 1376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h42v37H0z",
    transform: "translate(1851.061 1376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M.5.5h41v36H.5z",
    transform: "translate(1851.061 1376)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1256 1791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1256 1791)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1555 1791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1555 1791)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M8 0h18a8 8 0 0 1 8 8v34H0V8a8 8 0 0 1 8-8z",
    transform: "translate(1855 1791)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M8 .5h18A7.5 7.5 0 0 1 33.5 8v33a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V8A7.5 7.5 0 0 1 8 .5z",
    transform: "translate(1855 1791)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_475",
    "data-name": "Line 475",
    className: "cls-5",
    transform: "translate(1134.924 1821.333)",
    d: "M0 0h120.576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_489",
    "data-name": "Line 489",
    className: "cls-5",
    transform: "translate(1888.5 1821.333)",
    d: "M0 0h118.576"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_476",
    "data-name": "Line 476",
    className: "cls-5",
    transform: "translate(1289.5 1821.333)",
    d: "M0 0h266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_490",
    "data-name": "Line 490",
    className: "cls-5",
    transform: "translate(1589 1821.333)",
    d: "M0 0h266"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091",
    transform: "translate(882.81 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h117.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h117.19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092",
    transform: "translate(1341.81 -51.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374-2",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h257.251"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375-2",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h257.251"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(1640.81 -51.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_374-3",
    "data-name": "Line 374",
    className: "cls-5",
    transform: "translate(252 1433)",
    d: "M0 0h112.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_375-3",
    "data-name": "Line 375",
    className: "cls-5",
    transform: "translate(252 1458)",
    d: "M0 0h112.19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093",
    transform: "translate(944.477 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_383",
    "data-name": "Line 383",
    className: "cls-5",
    transform: "translate(353.333 1433)",
    d: "M0 0h253.686"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_384",
    "data-name": "Line 384",
    className: "cls-5",
    transform: "translate(353.333 1458)",
    d: "M0 0h253.686"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4495",
    "data-name": "Path 4495",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-7727.514 4737.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4502",
    "data-name": "Path 4502",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-7430.514 4737.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4496",
    "data-name": "Path 4496",
    className: "cls-5",
    d: "m9259.938-3330.348 1.547 3.336h11.066l1.709-3.336z",
    transform: "translate(-8026.692 4737.181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4497",
    "data-name": "Path 4497",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 641.566 636.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4498",
    "data-name": "Path 4498",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 791.313 636.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4501",
    "data-name": "Path 4501",
    className: "cls-5",
    d: "m0 0 2.188 6.336h15.656L20.262 0z",
    transform: "rotate(180 941.096 636.668)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TULU_ride_-_3_bikes_TOP",
    "data-name": "TULU ride - 3 bikes TOP",
    transform: "translate(-780 -1013)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087",
    transform: "rotate(90 -568.119 1525.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-5",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4491",
    "data-name": "Path 4491",
    className: "cls-6",
    d: "M367.166 0H0",
    transform: "translate(0 7.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-5",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-5",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088",
    transform: "rotate(-90 1915.584 972.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-6",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4491-2",
    "data-name": "Path 4491",
    className: "cls-6",
    d: "M367.166 0H0",
    transform: "translate(0 7.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-6",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-6",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Line_469",
    "data-name": "Line 469",
    className: "cls-2",
    transform: "translate(997.31 2370.5)",
    d: "M127.376 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_470",
    "data-name": "Line 470",
    className: "cls-2",
    transform: "translate(924.309 2091.5)",
    d: "M164.123 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_486",
    "data-name": "Line 486",
    className: "cls-2",
    transform: "translate(924.31 2894.5)",
    d: "M256.123 0H0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2048",
    "data-name": "Rectangle 2048",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h38v245.571H0z",
    transform: "translate(1096.424 2091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(1096.424 2091)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M0 0h38v245.571H0z",
    transform: "translate(2005 2091)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1.5 1.5h35v242.571h-35z",
    transform: "translate(2005 2091)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_477",
    "data-name": "Line 477",
    className: "cls-4",
    transform: "translate(1132.924 2093)",
    d: "M0 0h872.076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_478",
    "data-name": "Line 478",
    className: "cls-5",
    transform: "translate(1132.924 2152)",
    d: "M0 0h872.076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_479",
    "data-name": "Line 479",
    className: "cls-5",
    transform: "translate(1132.924 2238)",
    d: "M0 0h872.076"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_480",
    "data-name": "Line 480",
    className: "cls-4",
    transform: "translate(1285.5 2370.571)",
    d: "M0 0h277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_491",
    "data-name": "Line 491",
    className: "cls-4",
    transform: "translate(1584.5 2370.571)",
    d: "M0 0h277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4499",
    "data-name": "Path 4499",
    className: "cls-4",
    d: "M2800.5 493.25v37h130.076",
    transform: "translate(-1667.576 1840.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4503",
    "data-name": "Path 4503",
    className: "cls-4",
    d: "M2923.167 493.25v37H2800.5",
    transform: "translate(-916.5 1840.25)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(-1692.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(1130.322 930.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1599",
    "data-name": "Rectangle 1599",
    className: "cls-7",
    transform: "translate(1828.5 1487.642)",
    d: "M0 0h15.022v172.873H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1595",
    "data-name": "Rectangle 1595",
    className: "cls-8",
    transform: "translate(1824.5 1791.609)",
    d: "M0 0h22.532v172.641H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1682",
    "data-name": "Rectangle 1682",
    className: "cls-7",
    transform: "translate(1824.5 1307.926)",
    d: "M0 0h22.532v179.716H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2046",
    "data-name": "Rectangle 2046",
    className: "cls-8",
    transform: "translate(1824.5 1209.926)",
    d: "M0 0h22.532v11.716H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_75",
    "data-name": "Union 75",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_76",
    "data-name": "Union 76",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_78",
    "data-name": "Union 78",
    className: "cls-10",
    d: "M10.089 64.1C8.5 52.393 4.683 6.995 4.547 5.38H0V0h9.416v5.38H8.163c.03.813.513 12.814 3.823 33.632 3.43 21.571 6.43 28.285 3.43 31.286-1.313 1.313-2.189 2.572-2.893 2.572-.905 0-1.523-2.075-2.434-8.77z",
    transform: "translate(1805.69 1556.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_79",
    "data-name": "Union 79",
    className: "cls-10",
    d: "M10.088 64.1C8.433 52.848 4.678 6.994 4.546 5.38H0V0h9.415v5.38H8.166a341.8 341.8 0 0 1 4.211 35.82c.906 17.176 14.765 35.557 5.725 39.475a9.29 9.29 0 0 1-3.535.929C9.824 81.6 11.5 73.7 10.088 64.1z",
    transform: "rotate(180 938.925 851.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286",
    "data-name": "Path 4286",
    className: "cls-10",
    d: "m9882.065-4474.948 10.847-14.767v88.593l-10.847-13.861v-59.965",
    transform: "translate(-8036.213 6077.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287",
    "data-name": "Path 4287",
    className: "cls-10",
    d: "M9941.14-3628.215c-8.691-1.328-18.893-21.24 0-29.87",
    transform: "translate(-8113.463 5279.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4490",
    "data-name": "Path 4490",
    className: "cls-10",
    d: "M4291.667-88.833c-4.833-.167-8.658 1.784-9.667 7.333s-25.25 118.25-25.25 118.25-2.417 5.583 8.25 5.5 58.25 0 58.25 0 5.289-.689 4-5.5S4302-82.75 4302-82.75s-.5-6.25-10.333-6.083z",
    transform: "translate(-2456.015 1749.358)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_8_6",
    "data-name": "Component 8 \\u2013 6",
    transform: "translate(2836.306 2377.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4492",
    "data-name": "Path 4492",
    className: "cls-10",
    d: "M5542.054 708.667s-77.438-1-95.219 1.667-42.114 3-33.264 18 17.157 11 20.483 5.667c3.143-5.04-17.5-11.583 9-15.333s54.92-2.886 99-3.333",
    transform: "translate(-5411.693 -708.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4494",
    "data-name": "Path 4494",
    className: "cls-10",
    d: "M5411.694 708.667s77.438-1 95.219 1.667 42.114 3 33.264 18-17.157 11-20.483 5.667c-3.143-5.04 17.5-11.583-9-15.333s-54.92-2.886-99-3.333",
    transform: "translate(-5281.333 -708.483)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101",
    transform: "translate(-1093.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080-2",
    "data-name": "Group 1080",
    transform: "translate(1130.322 930.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1599-2",
    "data-name": "Rectangle 1599",
    className: "cls-7",
    transform: "translate(1828.5 1487.642)",
    d: "M0 0h15.022v172.873H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1595-2",
    "data-name": "Rectangle 1595",
    className: "cls-8",
    transform: "translate(1824.5 1791.609)",
    d: "M0 0h22.532v172.641H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1682-2",
    "data-name": "Rectangle 1682",
    className: "cls-7",
    transform: "translate(1824.5 1307.926)",
    d: "M0 0h22.532v179.716H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2046-2",
    "data-name": "Rectangle 2046",
    className: "cls-8",
    transform: "translate(1824.5 1209.926)",
    d: "M0 0h22.532v11.716H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_75-2",
    "data-name": "Union 75",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_76-2",
    "data-name": "Union 76",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_78-2",
    "data-name": "Union 78",
    className: "cls-10",
    d: "M10.089 64.1C8.5 52.393 4.683 6.995 4.547 5.38H0V0h9.416v5.38H8.163c.03.813.513 12.814 3.823 33.632 3.43 21.571 6.43 28.285 3.43 31.286-1.313 1.313-2.189 2.572-2.893 2.572-.905 0-1.523-2.075-2.434-8.77z",
    transform: "translate(1805.69 1556.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_79-2",
    "data-name": "Union 79",
    className: "cls-10",
    d: "M10.088 64.1C8.433 52.848 4.678 6.994 4.546 5.38H0V0h9.415v5.38H8.166a341.8 341.8 0 0 1 4.211 35.82c.906 17.176 14.765 35.557 5.725 39.475a9.29 9.29 0 0 1-3.535.929C9.824 81.6 11.5 73.7 10.088 64.1z",
    transform: "rotate(180 938.925 851.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286-2",
    "data-name": "Path 4286",
    className: "cls-10",
    d: "m9882.065-4474.948 10.847-14.767v88.593l-10.847-13.861v-59.965",
    transform: "translate(-8036.213 6077.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287-2",
    "data-name": "Path 4287",
    className: "cls-10",
    d: "M9941.14-3628.215c-8.691-1.328-18.893-21.24 0-29.87",
    transform: "translate(-8113.463 5279.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4490-2",
    "data-name": "Path 4490",
    className: "cls-10",
    d: "M4291.667-88.833c-4.833-.167-8.658 1.784-9.667 7.333s-25.25 118.25-25.25 118.25-2.417 5.583 8.25 5.5 58.25 0 58.25 0 5.289-.689 4-5.5S4302-82.75 4302-82.75s-.5-6.25-10.333-6.083z",
    transform: "translate(-2456.015 1749.358)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_8_7",
    "data-name": "Component 8 \\u2013 7",
    transform: "translate(2836.306 2377.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4492-2",
    "data-name": "Path 4492",
    className: "cls-10",
    d: "M5542.054 708.667s-77.438-1-95.219 1.667-42.114 3-33.264 18 17.157 11 20.483 5.667c3.143-5.04-17.5-11.583 9-15.333s54.92-2.886 99-3.333",
    transform: "translate(-5411.693 -708.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4494-2",
    "data-name": "Path 4494",
    className: "cls-10",
    d: "M5411.694 708.667s77.438-1 95.219 1.667 42.114 3 33.264 18-17.157 11-20.483 5.667c-3.143-5.04 17.5-11.583-9-15.333s-54.92-2.886-99-3.333",
    transform: "translate(-5281.333 -708.483)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096",
    transform: "translate(-1392.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080-3",
    "data-name": "Group 1080",
    transform: "translate(1130.322 930.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1599-3",
    "data-name": "Rectangle 1599",
    className: "cls-7",
    transform: "translate(1828.5 1487.642)",
    d: "M0 0h15.022v172.873H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1595-3",
    "data-name": "Rectangle 1595",
    className: "cls-8",
    transform: "translate(1824.5 1791.609)",
    d: "M0 0h22.532v172.641H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1682-3",
    "data-name": "Rectangle 1682",
    className: "cls-7",
    transform: "translate(1824.5 1307.926)",
    d: "M0 0h22.532v179.716H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2046-3",
    "data-name": "Rectangle 2046",
    className: "cls-8",
    transform: "translate(1824.5 1209.926)",
    d: "M0 0h22.532v11.716H0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union_75-3",
    "data-name": "Union 75",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "rotate(-180 959.087 858.044)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_76-3",
    "data-name": "Union 76",
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M20.163 31.558H14a14 14 0 0 1-14-14V14A14 14 0 0 1 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M39.325 30.558V1H14a12.915 12.915 0 0 0-9.192 3.808A12.915 12.915 0 0 0 1 14v3.558c0 3.473 1.352 6.737 3.807 9.192A12.916 12.916 0 0 0 14 30.558h25.325m1 1H14c-7.732 0-14-6.268-14-14V14C0 6.268 6.268 0 14 0h26.325v31.558z",
    transform: "translate(1765.366 1541.521)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_78-3",
    "data-name": "Union 78",
    className: "cls-10",
    d: "M10.089 64.1C8.5 52.393 4.683 6.995 4.547 5.38H0V0h9.416v5.38H8.163c.03.813.513 12.814 3.823 33.632 3.43 21.571 6.43 28.285 3.43 31.286-1.313 1.313-2.189 2.572-2.893 2.572-.905 0-1.523-2.075-2.434-8.77z",
    transform: "translate(1805.69 1556.131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_79-3",
    "data-name": "Union 79",
    className: "cls-10",
    d: "M10.088 64.1C8.433 52.848 4.678 6.994 4.546 5.38H0V0h9.415v5.38H8.166a341.8 341.8 0 0 1 4.211 35.82c.906 17.176 14.765 35.557 5.725 39.475a9.29 9.29 0 0 1-3.535.929C9.824 81.6 11.5 73.7 10.088 64.1z",
    transform: "rotate(180 938.925 851.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4286-3",
    "data-name": "Path 4286",
    className: "cls-10",
    d: "m9882.065-4474.948 10.847-14.767v88.593l-10.847-13.861v-59.965",
    transform: "translate(-8036.213 6077.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4287-3",
    "data-name": "Path 4287",
    className: "cls-10",
    d: "M9941.14-3628.215c-8.691-1.328-18.893-21.24 0-29.87",
    transform: "translate(-8113.463 5279.147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4490-3",
    "data-name": "Path 4490",
    className: "cls-10",
    d: "M4291.667-88.833c-4.833-.167-8.658 1.784-9.667 7.333s-25.25 118.25-25.25 118.25-2.417 5.583 8.25 5.5 58.25 0 58.25 0 5.289-.689 4-5.5S4302-82.75 4302-82.75s-.5-6.25-10.333-6.083z",
    transform: "translate(-2456.015 1749.358)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_8_8",
    "data-name": "Component 8 \\u2013 8",
    transform: "translate(2836.306 2377.483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4492-3",
    "data-name": "Path 4492",
    className: "cls-10",
    d: "M5542.054 708.667s-77.438-1-95.219 1.667-42.114 3-33.264 18 17.157 11 20.483 5.667c3.143-5.04-17.5-11.583 9-15.333s54.92-2.886 99-3.333",
    transform: "translate(-5411.693 -708.483)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4494-3",
    "data-name": "Path 4494",
    className: "cls-10",
    d: "M5411.694 708.667s77.438-1 95.219 1.667 42.114 3 33.264 18-17.157 11-20.483 5.667c-3.143-5.04 17.5-11.583-9-15.333s-54.92-2.886-99-3.333",
    transform: "translate(-5281.333 -708.483)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "side_view_02",
    "data-name": "side view 02",
    transform: "translate(-924 -1013)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097",
    transform: "translate(2271.81 1904.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-7",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-5",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M90.499 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-7",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-7",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    transform: "rotate(180 1270.09 959.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791-8",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_233-6",
    "data-name": "Line 233",
    className: "cls-2",
    transform: "translate(.001 7.227)",
    d: "M95.868 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_231-8",
    "data-name": "Line 231",
    className: "cls-3",
    d: "M11.498 0 0 7.226"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_232-8",
    "data-name": "Line 232",
    className: "cls-3",
    transform: "translate(0 7.227)",
    d: "M11.498 7.226 0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_481",
    "data-name": "Line 481",
    className: "cls-2",
    transform: "translate(2265.5 1842.667)",
    d: "M0 0v93.166"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_25.00-2",
    "data-name": 25,
    className: "cls-1",
    transform: "translate(2373.119 1919.333)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25.00"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_484",
    "data-name": "Line 484",
    className: "cls-4",
    transform: "translate(2400.119 1384.077)",
    d: "M126.768 0H0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_482",
    "data-name": "Line 482",
    className: "cls-4",
    transform: "translate(2265.31 1833.833)",
    d: "M126.768 0H0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_483",
    "data-name": "Line 483",
    className: "cls-4",
    transform: "translate(2265.5 1381.833)",
    d: "M0 451.848 136.81 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line_485",
    "data-name": "Line 485",
    className: "cls-4",
    transform: "translate(2392.078 1381.833)",
    d: "M0 451.848 136.81 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4500",
    "data-name": "Path 4500",
    className: "cls-4",
    d: "M6577-3273.865h146.6c10.092 0 6.025-8.033 0-9.708s-138.274-17.194-138.274-17.194z",
    transform: "translate(-4184.69 5107.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_126",
    "data-name": "Union 126",
    className: "cls-9"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m67.061 232.308 12.048-42.022L0 3.925 9.243 0l80.793 190.329-.559.237-12.763 44.512z",
    transform: "translate(2312.842 1192.815)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m74.657 231.367 11.909-41.535L7.654 3.934l-3.72 1.58 78.352 184.578-11.514 40.16 3.885 1.115m2.057 3.711-9.653-2.77 12.048-42.021L0 3.925 9.243 0l80.793 190.329-.56.237-12.762 44.512z",
    style: {
      fill: "#000",
      stroke: "none"
    },
    transform: "translate(2312.842 1192.815)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line_488",
    "data-name": "Line 488",
    className: "cls-2",
    transform: "translate(2545.31 1842.667)",
    d: "M0 0v93.166"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargebicyclestand);
export default __webpack_public_path__ + "static/media/large bicycle stand.2ec14957187351e3ef6a1423dc1b7200.svg";
export { ForwardRef as ReactComponent };